import { useApp } from 'contexts/app';
import { useAuth } from 'contexts/auth';
import { useTranslation } from 'react-i18next';
import { UploadFileDialog } from 'shell/components';
import { SUBMISSION_ALLOWED_FILE_TYPES } from 'utils/constants';

const UploadSubmissionDialog = ({ open, assignment, onClose, onClick }) => {
    const { course } = useApp();
    const { auth } = useAuth();
    const { t } = useTranslation('assignment');

    const handleClickUpload = (files) => {
        onClose();
        const folders = files.map((file) => {
            return {
                submitted_at: new Date().getTime(),
                files: [
                    {
                        ...file,
                        owner_account_id: auth.id,
                        course_id: course.id,
                        assignment_id: assignment.id,
                    },
                ],
            };
        });
        onClick(folders);
    };

    return (
        <UploadFileDialog
            allowedFileTypes={SUBMISSION_ALLOWED_FILE_TYPES}
            description={t(
                'submission.upload-file-description-500mb',
                'Please make sure your file is no larger than 500MB.'
            )}
            max={1}
            open={open}
            title={t('upload-submission_one', 'Upload Submission')}
            onClickUpload={handleClickUpload}
            onClose={onClose}
        />
    );
};

export default UploadSubmissionDialog;
